import { render, staticRenderFns } from "./ShutterType.vue?vue&type=template&id=2b1928ec&scoped=true"
import script from "./ShutterType.vue?vue&type=script&lang=ts"
export * from "./ShutterType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1928ec",
  null
  
)

export default component.exports